// extracted by mini-css-extract-plugin
export default {"btn":"viewAllButton_btn__VL8vB"};